import { TripPingLight } from './trip-ping-light.model';

export class TripPath {

  public displayed = true;
  public firstPing: TripPingLight;
  public lastPing: TripPingLight;
  public nextPath: TripPath;

  constructor(
    public pings: TripPingLight[],
    public distanceInMetersWithNextPath: number,
    public ellapsedTimeInSecondsWithNextPath: number
  ) {
    this.firstPing = pings[0];
    this.lastPing  = pings[pings.length - 1];
  }

  public canBeSkipped(): boolean {
    const tooMuchDistance     = this.distanceInMetersWithNextPath > 10000;
    const tooMuchTimeEllapsed = this.ellapsedTimeInSecondsWithNextPath / 3600 > 1;
    return (tooMuchDistance || tooMuchTimeEllapsed) && this.pings.length < 3;
  }

  public durationInSec(): number {
    return this.lastPing.createdAt.diff(this.firstPing.createdAt, 'seconds');
  }

  public addPing(ping: TripPingLight) {
    this.pings.push(ping);
  }

  public setLastPing(ping: TripPingLight) {
    this.lastPing = ping;
  }
}

export class TripDevicePath {

  public displayed      = true;
  public selectAllPaths = true;

  constructor(
    public deviceId: string,
    public paths: TripPath[]
  ) {
  }

  /**
   * Link the paths between one another to make a chained list
   */
  chainPathsBetweenOneAnother(): void {
    this.paths.forEach((path, index) => path.nextPath = this.nextDisplayedPath(index));
  }

  /**
   * Fetch the next path to display starting to look from the index and checking if the path is displayed
   *
   * @param index value from which we start to look in the array of paths
   */
  nextDisplayedPath(index: number): TripPath {
    return this.paths.find((value, i) => i > index && value.displayed);
  }

  getLastPath(): TripPath {
    if (this.paths.length > 0) {
      return this.paths[this.paths.length - 1];
    }
  }
}

export interface TripPathOptions {
  excludeIsolatedPings: boolean;
  hidePingsAfterDestinationHit: boolean;
}
